import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { PollsOptions } from '@/model/polls';

export interface PollsResultOptionRowProps {
  rank: number;
  option: PollsOptions;
  percentage: number;
  maxPercentage: number;
  isWinner: boolean;
}

export const PollsResultOptionRow = ({ rank, option, percentage, maxPercentage, isWinner }: PollsResultOptionRowProps) => {
  const barWidth = maxPercentage > 0 ? (percentage / maxPercentage) * 100 : 0;

  return (
    <Flex alignItems='center' gap={3}>
      <Text w='16px' fontWeight='bold' color='gray.500'>
        {rank}
      </Text>

      {option.image_url ? (
        <Image src={option.image_url} alt={option.option_text} w='32px' h='32px' borderRadius='full' objectFit='cover' />
      ) : null}

      <Text minW='96px' fontWeight={isWinner ? 'bold' : 'normal'} color={isWinner ? 'brand.500' : undefined}>
        {option.option_text}
      </Text>

      <Box flex='1' bg='gray.100' borderRadius='full' h='8px' overflow='hidden'>
        <Box bg={isWinner ? 'brand.500' : 'gray.400'} h='100%' borderRadius='full' width={`${barWidth}%`} />
      </Box>

      <Text minW='90px' textAlign='right' color='gray.600'>
        {option.votes} votos
      </Text>
      <Text minW='56px' textAlign='right' fontWeight='bold' color={isWinner ? 'brand.500' : undefined}>
        {percentage.toFixed(1)}%
      </Text>
    </Flex>
  );
};
